export const getApiHeaders = (headers = {}) => {
   return {
      'content-type': 'application/json',
      carrierCode: sessionStorage.getItem('carrierCode') || null,
      ...headers,
   };
};
